import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, take } from 'rxjs';

import { CopyService } from '@amfam/shared/utility/shared-services';
import { ToasterService } from '@amfam/ui-kit';

import { AutoPaySetupActions, AutoPaySetupSelectors } from '../../..';

@Component({
  selector: 'ds-hs-auto-pay-confirmation-wrapper',
  templateUrl: './hs-auto-pay-confirmation-wrapper.component.html',
  styleUrls: ['./hs-auto-pay-confirmation-wrapper.component.scss'],
  standalone: false
})
export class HsAutoPayConfirmationWrapperComponent implements OnInit, OnDestroy {
  // The below details should be pulled from store once billingAPI & iframe are integrated.
  data = {
    selectedPaymentAmount: 23.99,
    frequency: 'Installments',
    cardDetails: 'Mastercard 1234'
  };

  primaryButtonName: string;

  riskDescription: string;

  private stop$ = new Subject<void>();

  constructor(
    private store: Store,
    private copyService: CopyService,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.store
      .select(AutoPaySetupSelectors.selectActiveSetup)
      .pipe(take(1))
      .subscribe(setup => {
        this.riskDescription = setup.billAccount.riskDescription;
      });

    this.primaryButtonName = this.copyService.getCopy('shared.close');
  }

  close() {
    this.store.dispatch(AutoPaySetupActions.previousStep());
    const message = this.copyService.getCopy('billing.recurring.confirmationToastMessage');
    this.toasterService.pop('success', message);
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
